module.exports = __webpack_public_path__ + "img/qq1.78236536.jpg";